import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './Alert.scss';
import { SIZE } from '../../constants';
import { SvgCross } from '../../index';
import { Icon } from '../icon/Icon';
import { TertiaryBtn } from '../btn/TertiaryBtn';
export { SIZE };
export const Alert = ({ type, size = SIZE.SML, icon, children, onHideBtnClick, testId, }) => {
    let className = '';
    className += ' sg-alert-' + type;
    className += size === SIZE.SML ? ' sg-alert-sml' : '';
    className += size === SIZE.MED ? ' sg-alert-med' : '';
    return (_jsxs("p", { className: 'sg-alert' + className, role: 'alert', children: [_jsx("span", { className: 'sg-alert--icon', children: _jsx(Icon, { element: icon, size: size }) }), _jsx("span", { className: 'sg-alert--text', children: children }), onHideBtnClick && (_jsx("span", { className: 'sg-alert--hide', children: _jsx(TertiaryBtn, { icon: { element: _jsx(SvgCross, {}) }, isDanger: true, size: SIZE.MED, onClick: onHideBtnClick, testId: testId }) }))] }));
};
//# sourceMappingURL=Alert.js.map